
import { useState } from "react";
import { Dialog } from "@/components/ui/dialog";
import { DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { SocialIcons } from "../SocialIcons";

export const Header = () => {
  const [showEasterEgg, setShowEasterEgg] = useState(false);

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-sm border-b">
      <div className="p-4 flex flex-col sm:flex-row justify-between items-center gap-4 w-full max-w-7xl mx-auto">
        <Link 
          to="/"
          className="text-center sm:text-left font-mono text-base sm:text-lg md:text-xl font-bold text-primary hover:text-secondary transition-colors px-2"
          onClick={() => setShowEasterEgg(true)}
        >
          OnArriveBientot.NLocale.fr
        </Link>
        <nav className="flex gap-4 items-center">
          <Button variant="ghost" asChild>
            <Link to="/particulier">Particuliers</Link>
          </Button>
          <Button variant="ghost" asChild>
            <Link to="/pro">Professionnels</Link>
          </Button>
          <SocialIcons />
        </nav>
      </div>

      <Dialog open={showEasterEgg} onOpenChange={setShowEasterEgg}>
        <DialogContent className="sm:max-w-md text-center mx-4">
          <div className="space-y-4">
            <img 
              src="https://media.giphy.com/media/v1.Y2lkPTc5MGI3NjExcDd5Z3E2ZWV0Y2wxeWsyOXJ0NmQ2bXBxbWt0ZHd2YnBxaXIyYmx6eCZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/cMso9wDwqSy3e/giphy.gif" 
              alt="Chèvre qui danse" 
              className="mx-auto rounded-lg w-full max-w-[300px]"
            />
            <p className="text-xl font-mono font-bold">Vous êtes un pro, vous !</p>
          </div>
        </DialogContent>
      </Dialog>
    </header>
  );
};
